import { type Editor } from '@tiptap/react';
import { createContext, useContext } from 'react';

export type PageEditorApi = {
  insertHtmlIntoSection: (args: {
    sectionName: string;
    htmlContent: string;
    position?: 'start' | 'end';
  }) => boolean;
  setSectionHtml: (args: {
    sectionName: string;
    htmlContent: string;
    editable?: boolean;
  }) => boolean;
  focusSection: (args: { sectionName: string; position?: 'start' | 'end' }) => boolean;
  getSections: () => import('./page-editor-sections').PageEditorUpdatedSection[];
  getPdf: () => Promise<File | null>;
  printPdf: () => Promise<boolean>;
};

interface PageEditorContextValue {
  editor: Editor | null;
  api: PageEditorApi;
}

export const PageEditorContext = createContext<PageEditorContextValue | null>(null);

const usePageEditorContext = () => {
  const context = useContext(PageEditorContext);
  if (!context) {
    throw new Error('Missing PageEditorProvider');
  }
  return context;
};

export const usePageEditor = () => usePageEditorContext().api;

export const usePageEditorInternal = () => usePageEditorContext().editor;
